"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerMemberCardsContract = void 0;
const contract_1 = require("../base/contract");
const api_schemas_1 = require("../../schemas/base/api.schemas");
const member_cards_schemas_1 = require("../../schemas/customer/member-cards.schemas");
exports.CustomerMemberCardsContract = (0, contract_1.createContract)({
    name: 'CustomerMemberCards',
    baseUrl: '/member-cards',
    version: '1',
    serviceModule: 'user',
    endpoints: {
        listMemberCards: {
            method: 'GET',
            path: '/',
            body: null,
            query: member_cards_schemas_1.listMemberCardsQuerySchema,
            params: null,
            headers: null,
            response: {
                success: member_cards_schemas_1.listMemberCardsResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required'],
            documentation: {
                summary: 'List assigned member cards',
                description: 'Retrieves the authenticated customer’s active personal and company member cards without financial data.',
                tags: ['Customer', 'Member Cards'],
                deprecated: false,
            },
            tests: [
                'should return only active cards assigned to the authenticated customer',
                'should exclude balances, points, history and group rosters',
                'should not accept a client user identity override',
            ],
        },
        getMemberCardBalances: {
            method: 'GET',
            path: '/:cardId/balances',
            body: null,
            query: null,
            params: member_cards_schemas_1.getMemberCardBalancesParamsSchema,
            headers: null,
            response: {
                success: member_cards_schemas_1.getMemberCardBalancesResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required'],
            documentation: {
                summary: 'Get current member card balances',
                description: 'Retrieves the latest separately received prepaid and bonus values for one authorized member card.',
                tags: ['Customer', 'Member Cards'],
                deprecated: false,
            },
            tests: [
                'should return the latest prepaid and bonus receipts independently',
                'should require current authenticated card assignment',
                'should distinguish missing receipts from supplied zero',
            ],
        },
    },
});
